import { Injectable } from '@angular/core';

@Injectable()
export class TokenService {
  constructor() {}

  getToken(): String {
    return localStorage.getItem('token');
  }

  setToken(token: string) {
    localStorage.setItem('token', token);
  }

  removeToken() {
    localStorage.removeItem('token');
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/services/token.service.ts